// extracted by mini-css-extract-plugin
export default {"container":"login_container__VBEcj","panel":"login_panel__y84cA","form":"login_form__6L4D1","error":"login_error__9L0X9"};